/**
 * @Description: 用户自定义类别信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  MaterialCategoryUserModel,
  MaterialCategoryUserSearchModel,
  MaterialCategoryUserPageSearchModel,
  MaterialCategoryUserAddModel,
  MaterialCategoryUserUpdateModel,
  IdsModel
} from '@/model/product/MaterialCategoryUserModel'

const baseUrl = Route.product + '/materialCategoryUser'

/**
 * 搜索分页数据
 */
export const pageSearchMaterialCategoryUser = (param: MaterialCategoryUserPageSearchModel) => {
  return https().request<RootObject<PageRespModel<MaterialCategoryUserModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchMaterialCategoryUser = (param: MaterialCategoryUserSearchModel) => {
  return https().request<RootObject<MaterialCategoryUserModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getMaterialCategoryUser = (id: number) => {
  return https().request<RootObject<MaterialCategoryUserModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addMaterialCategoryUser = (param: MaterialCategoryUserAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateMaterialCategoryUser = (param: MaterialCategoryUserUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeMaterialCategoryUser = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveMaterialCategoryUser = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
